import FetchInterceptor from "configs/FetchInterceptor";

class StockCategoryServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/categories/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/categories/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async getByIds(requestBody) {
    const apiUrl = "/core/v1/categories/get/data";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/categories/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async update(requestBody) {
    const apiUrl = "/core/v1/categories/update";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async uploadImage(requestBody) {
    const apiUrl = "/core/v1/categories/upload/images";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default StockCategoryServices;
